import { actionGenerator, IReduxAction } from '../../utils/actions';

export const LOAD_BET_POSITION_START = 'BET_POSITION :: LOAD_BET_POSITION_START';

export type TLoadBetPositionStartAction = IReduxAction<typeof LOAD_BET_POSITION_START>;

export const loadBetPositionStart = actionGenerator<typeof LOAD_BET_POSITION_START>(LOAD_BET_POSITION_START);
